module.exports = require("@nextcloud/l10n/dist/gettext");